import React from 'react';
import withHover from '../../hocs/withHover';
import AccessiblyHiddenChoice from '../AccessiblyHiddenChoice';
import OptionLabel from './OptionLabel';
import withFocus from '../../hocs/withFocus';
import { withFormProps } from '../../hocs/withFormProps/withFormProps';
import mergeFocusHandlers from '../../utils/mergeFocusHandlers';
/** should not be used outside of Select */
export const Option = React.forwardRef(({ labelText, name, value, selectedValue, disabled = false, isInitial = false, dontRegister = false, noTab = false, noBorder = false, isPlaceholder = false, onClick, isHovered, handleMouseEnter, handleMouseLeave, isFocused, handleBlur, handleFocus, onBlur, styles, optionLabelStyles, ...rest }, ref) => {
    const shouldRegister = !isInitial && !dontRegister;
    const focusHandlers = mergeFocusHandlers({ handleBlur, handleFocus, onBlur });
    const isSelected = typeof selectedValue === 'string' &&
        selectedValue.toLocaleLowerCase() === value.toLocaleLowerCase();
    const mergedStyles = {
        position: 'relative',
        ...styles
    };
    return (React.createElement("div", { style: mergedStyles, role: "listbox" },
        React.createElement(AccessiblyHiddenChoice, { type: "radio", name: name, 
            // placeholder must be disabled to be removed from tabbing order
            disabled: disabled || isInitial, onClick: onClick, isHovered: isHovered, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, handleBlur: handleBlur, ref: shouldRegister ? ref : undefined, value: value, noTab: noTab, ...focusHandlers, ...rest, role: "option" }),
        React.createElement(OptionLabel, { htmlFor: name, isFocused: isFocused, isHovered: isHovered, isSelected: isSelected, isInitial: isInitial, noBorder: noBorder, disabled: disabled, isPlaceholder: isPlaceholder, styles: optionLabelStyles }, labelText)));
});
export default withHover(withFocus(withFormProps(Option)));
//# sourceMappingURL=index.js.map